module.exports = __webpack_public_path__ + "static/logoWithText-fa485a31aea0b8f118c66bdbd9a1243b.svg";